import { useDispatch, useSelector } from 'react-redux';
import { AsyncCreateBaseCustomViewWizard } from 'find-and-filter-components/custom-views-build/public/AsyncCreateBaseCustomViewWizard';
import { getGatesArray, getIsUngatedForLimitedTicketFunctionality } from '../../selectors/gateSelectors';
import { getScopes } from '../../selectors/userSelectors/getScopes';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { addedViewDetails, appliedFilters, viewCreationStarted } from '../constants/events';
import { createViewError } from '../actions/createViewError';
import { setCurrentThreadList } from '../../thread-list/actions/setCurrentThreadList';
import { fetchCustomView } from 'find-and-filter-data/views-data/public';
import { CALL_TYPE_ID, CONVERSATION_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
export const CreateCustomViewWizard = ({
  onReject,
  onSuccess
}) => {
  const dispatch = useDispatch();
  const gates = useSelector(getGatesArray);
  const scopes = useSelector(getScopes);
  const inboxId = useSelector(getCurrentInboxId);
  const shouldLimitTicketFunctionality = useSelector(getIsUngatedForLimitedTicketFunctionality);
  return /*#__PURE__*/_jsx(AsyncCreateBaseCustomViewWizard, {
    gates: gates,
    inboxId: inboxId,
    objectTypeIds: shouldLimitTicketFunctionality ? [CALL_TYPE_ID, CONVERSATION_TYPE_ID] : [CALL_TYPE_ID, CONVERSATION_TYPE_ID, TICKET_TYPE_ID],
    onConfirm: filters => {
      trackEvent(viewCreationStarted({
        isNewView: true,
        filters
      }));
    },
    onFilterChange: () => {
      trackEvent(appliedFilters({
        isNewView: true
      }));
    },
    onStepChange: prevStepIndex => {
      const VIEW_DETAILS_PAGE_STEP = 0;
      if (prevStepIndex === VIEW_DETAILS_PAGE_STEP) {
        trackEvent(addedViewDetails({
          isNewView: true
        }));
      }
    },
    onError: error => {
      dispatch(createViewError(error));
    },
    onReject: onReject,
    onSuccess: processingCustomView => {
      onSuccess();
      dispatch(fetchCustomView({
        customViewId: processingCustomView.id
      })).unwrap().then(customView => {
        dispatch(setCurrentThreadList(customView));
      }).catch(error => {
        dispatch(createViewError(error));
      });
    },
    scopes: scopes
  });
};
CreateCustomViewWizard.displayName = 'CreateCustomViewWizard';